import React, { ChangeEvent, FunctionComponent } from 'react'
import { useFormContext } from 'react-hook-form'
import { Checkbox } from '@afterpaytouch/core'
import { CheckboxFieldSchema } from '../../types'
import { useVisible } from '../../utils/hooks'

export const CheckboxField: FunctionComponent<CheckboxFieldSchema> = ({ name = '', props, options, show = true, testNameSpace = '' }) => {
  const { register, setValue } = useFormContext()
  const { isVisible, values } = useVisible({ name, show })

  const component = register(name, {
    ...options,
    value: values ?? props?.defaultChecked ?? false,
  })

  const handleOnChange = ({ target }: ChangeEvent<HTMLInputElement>): void => {
    setValue(name, target.checked, {
      shouldValidate: true,
    })
  }

  return isVisible ? <Checkbox {...props} name={component.name} onChange={handleOnChange} testNameSpace={testNameSpace} /> : null
}
